export default () => ({
  component: 'currency-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
